import { type Common, common } from '@libs/domain';
import { Item, type Items } from '@ps-smart-cp/ppfw-client';

export const ledgerFooterFieldConfig = {
  entryDate: Item.of(common.names.entryDate, common.attributes.entryDate),
  approvalNo: Item.of(common.names.approvalNo, common.attributes.approvalNo),
  summary: Item.of(common.names.summary, common.attributes.summary),
} satisfies Items<Common['schema']>;
